function initCollectionSwitcher() {
  document.querySelectorAll('.collection-switcher').forEach((switcher) => {
    const sectionId = switcher.dataset.sectionId;
    const grid = switcher.querySelector(`#collection-switcher-grid-${sectionId}`);

    switcher.querySelectorAll('.collection-switcher__item').forEach((btn) => {
      btn.addEventListener('click', async () => {
        const handle = btn.dataset.collectionHandle;
        const url = `/collections/${handle}?section_id=${sectionId}`;
        const res = await fetch(url);
        const html = await res.text();

        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newGrid = doc.querySelector(`#collection-switcher-grid-${sectionId}`);

        if (newGrid) {
          grid.innerHTML = newGrid.innerHTML;
        }
      });
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCollectionSwitcher);
} else {
  initCollectionSwitcher();
}